import { useSyncExternalStore } from 'react';

/**
 * Breakpoints do playbook (§ Densidade e grade): a sidebar colapsa sozinha no
 * tablet e vira drawer off-canvas no mobile.
 */
export const BREAKPOINT_TABLET = '(max-width: 1279px)';
export const BREAKPOINT_MOBILE = '(max-width: 767px)';

export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (notificar) => {
      const lista = window.matchMedia(query);
      lista.addEventListener('change', notificar);
      return () => lista.removeEventListener('change', notificar);
    },
    () => window.matchMedia(query).matches,
    () => false,
  );
}
